import React, { useEffect } from 'react';
import { LoadingSpinner } from '../common/loadingSpinner';
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import Result from './Result';
import RecombeeResultsContainer from './RecombeeResultsContainer';
import Pagination from '../utils/pagination';
import { setCurrentPage, setTotalResults } from '../redux/settings/page-settings-slice';

export default function ResultsContainer() {
    const dispatch = useAppDispatch();

    const { query, page, pageSize, searchActive, totalResults, noResultsText } = useAppSelector((state) => state.pageSettings);
    const { types, tags } = useAppSelector((state) => state.filterState);
    const { searchResults, error, isLoading } = useAppSelector((state) => state.searchData);

    useEffect(() => {
        if (totalResults !== undefined) {
            dispatch(setTotalResults(totalResults));
        }
    }, [totalResults]);

    const handlePageChange = (newPage: number) => {
        dispatch(setCurrentPage(newPage));
    };

    if (!searchActive || !query || query.trim() === '') {
        return null;
    }

    return (
        <div className="search-result-container">

            {searchResults.length > 0 ?
                <>
                    <ul className="search-result-list">
                        <RecombeeResultsContainer />
                        {searchResults.map((page, index) => (
                            <Result result={page} id={page.id} key={`${page.id}-${index}`} />
                        ))}
                    </ul>

                    <Pagination
                        currentPage={page}
                        totalCount={totalResults}
                        pageSize={pageSize}
                        onPageChange={handlePageChange}
                        siblingCount={1}
                        className="space-top-xl" />
                </>
                :
                <div className="search-no-results space-top-lg">
                    {<div className="rich-text rich-text-full-width" dangerouslySetInnerHTML={{ __html: noResultsText }} />}
                </div>
            }

        </div>
    );
}